class SelectClass {
// 圃場一覧絞り込み検索
  public sortOrderList: {text: string, value: number}[] = [
    { text: '現在地から近い順', value: 1 },
    { text: '収穫適期が近い順', value: 2 }
  ]
  public sortFieldList: {text: string, value: number}[] = [
    { text: 'グループ圃場のみ', value: 0 },
    { text: 'すべて', value: 1 }
  ]
  // 圃場追加/編集
  public tempSourceList: {text: string, value: number}[] = [
    { text: '計測センサー優先', value: 1 },
    { text: 'メッシュ気候のみ', value: 2 }
  ]
  public rainfallSourceList: {text: string, value: number}[] = [
    { text: '計測センサー優先', value: 1 },
    { text: 'メッシュ気候のみ', value: 2 }
  ]
  // 圃場一覧
  public groupList: {text: string, value: string}[] = [
    { text: '地区', value: '1' },
    { text: '品種', value: '2' },
    { text: '生産者', value: '3' }
  ]
}

export default new SelectClass()
